// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/ce9b34aada0a7c500a79.bundle.js";
	if (chunkId === 3) return "static/js/06c89c1f7ecd8ff8b031.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"828cbd2565c221456beb","136":"d87f0a4c56b6e0f78455","137":"8ef45ca990347043eb6d"}[chunkId] + ".chunk.js";
};